import User from './User'

export default class Member extends User {
  resource() {
    return 'members'
  }
}
